import React from 'react';
import StaffFormPage from './StaffFormPage';

const StaffCreate = () => {
  return (
    <StaffFormPage />
  );
};

export default StaffCreate;